const schema = [
        ['startDate'],
        ['factor'],
        ['user'],
];

export default schema;
